import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative min-h-[700px] md:min-h-[800px] flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-primary-900 to-slate-800">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-primary-600/20 via-transparent to-transparent"></div>
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,_var(--tw-gradient-stops))] from-cta-600/10 via-transparent to-transparent"></div>
        {/* Subtle pattern overlay */}
        <div className="absolute inset-0 opacity-[0.03]" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 py-24 md:py-32 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 text-white/90 text-xs md:text-sm font-medium px-4 py-2 rounded-full mb-6 animate-fade-in-up">
          <span className="w-2 h-2 bg-cta-400 rounded-full animate-pulse"></span>
          India&apos;s Most Trusted Insurance Advisory Platform
        </div>

        {/* Headline */}
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-5 max-w-5xl mx-auto animate-fade-in-up" style={{ animationDelay: "0.1s" }}>
          Get Expert Insurance Advice{" "}
          <span className="text-primary-300">Before You Buy</span>
        </h1>

        {/* Subheadline */}
        <p className="text-base md:text-lg lg:text-xl text-white/80 max-w-3xl mx-auto mb-10 leading-relaxed animate-fade-in-up" style={{ animationDelay: "0.2s" }}>
          Compare Health, Term, Life, Car, Travel, Marine & Corporate Insurance plans with
          <span className="text-white font-semibold"> expert guidance</span> and{" "}
          <span className="text-white font-semibold">lifetime claims support</span>.
          No biased recommendations. Only transparent advice.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 mb-10 animate-fade-in-up" style={{ animationDelay: "0.3s" }}>
          <Link
            to="/book-appointment?source=Homepage"
            className="w-full sm:w-auto bg-cta-600 hover:bg-cta-700 text-white font-bold text-sm md:text-base px-6 md:px-8 py-3.5 md:py-4 rounded-full shadow-lg shadow-cta-600/30 hover:shadow-xl hover:shadow-cta-600/40 transition-all hover:-translate-y-0.5 whitespace-nowrap flex items-center justify-center gap-2"
          >
            <i className="ri-calendar-check-line text-lg"></i>
            Book Free Consultation
          </Link>
          <Link
            to="/compare-plans"
            className="w-full sm:w-auto bg-white hover:bg-white/90 text-slate-900 font-bold text-sm md:text-base px-6 md:px-8 py-3.5 md:py-4 rounded-full shadow-lg hover:shadow-xl transition-all hover:-translate-y-0.5 whitespace-nowrap flex items-center justify-center gap-2"
          >
            <i className="ri-arrow-left-right-line text-lg"></i>
            Compare Plans
          </Link>
          <Link
            to="/calculators"
            className="w-full sm:w-auto bg-primary-600/90 hover:bg-primary-600 text-white font-bold text-sm md:text-base px-6 md:px-8 py-3.5 md:py-4 rounded-full shadow-lg hover:shadow-xl transition-all hover:-translate-y-0.5 whitespace-nowrap flex items-center justify-center gap-2"
          >
            <i className="ri-calculator-line text-lg"></i>
            Get Instant Quote
          </Link>
          <a
            href="https://wa.me/919999365655?text=Hi%20ExpertAdvise%2C%20I%20need%20insurance%20advice"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto bg-green-500/90 hover:bg-green-500 text-white font-bold text-sm md:text-base px-6 md:px-8 py-3.5 md:py-4 rounded-full shadow-lg hover:shadow-xl transition-all hover:-translate-y-0.5 whitespace-nowrap flex items-center justify-center gap-2"
          >
            <i className="ri-whatsapp-line text-lg"></i>
            WhatsApp Expert
          </a>
        </div>

        {/* Trust Stats */}
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 text-white/70 text-sm animate-fade-in-up" style={{ animationDelay: "0.4s" }}>
          <div className="flex items-center gap-2">
            <i className="ri-shield-check-line text-primary-400 text-lg"></i>
            <span>50,000+ Happy Customers</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-star-fill text-amber-400 text-lg"></i>
            <span>4.9/5 Rating</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-phone-line text-cta-400 text-lg"></i>
            <span>15 Min Response Time</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-verified-badge-line text-blue-400 text-lg"></i>
            <span>IRDAI Licensed</span>
          </div>
        </div>

        {/* Partner Logos */}
        <div className="mt-12 pt-8 border-t border-white/10 animate-fade-in-up" style={{ animationDelay: "0.5s" }}>
          <p className="text-xs text-white/50 uppercase tracking-widest mb-4">Trusted by leading insurance partners</p>
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 opacity-60">
            {["LIC", "HDFC Life", "ICICI Prudential", "Max Life", "SBI Life", "Bajaj Allianz", "Star Health", "Care Health"].map(
              (partner) => (
                <span key={partner} className="text-white/70 text-sm font-semibold tracking-wide">
                  {partner}
                </span>
              )
            )}
          </div>
        </div>
      </div>
    </section>
  );
}